module.exports = "/Haha@2x-5c81a95ceb1d52ca5b6ce371667578a6.png";